//
//
//
//
//
//
//
//
//
//
//
//
//

import cursos from '@/data/cursos.js'
import { cursoMeta } from '@/data/curso-meta'

export default {
  data() {
    return {
      cursosArray: [],
      curso: {},
      isLoaded: false,
      checkClass: 'pos-graduacao',
    }
  },

  async asyncData({ params }) {
    let slug = params.slug
    let metadata = cursos.find((c) => c.slug === slug)
    return { metadata }
  },

  head() {
    let url = this.checkClass
    let fbid =
      this.curso.slug === 'mba-em-gestao-universitaria'
        ? '598314185051834'
        : '390367489652187'
    return cursoMeta(this.metadata, fbid, url)
  },
  computed: {
    isup() {
      return this.$attrs.isup
    },
    onFooter() {
      return this.$attrs.onFooter
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setPos(to.params.slug)
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.setPos(to.params.slug)
    next()
  },
  methods: {
    setPos(to) {
      this.isLoaded = false
      this.curso = {}
      this.cursosArray = []

      scrollTo(0, 0)

      let filterCurso = cursos.find((c) => c.slug === to)

      this.curso = filterCurso ? filterCurso : open('/404', '_self')

      let filterCursos = cursos
        .filter((c) => c.slug !== to && c.categoria === 'Pós-graduação')
        .filter((c) => c.listar !== false)

      this.cursosArray = filterCursos ? filterCursos : open('/404', '_self')

      this.isLoaded = true
    },
  },

  mounted() {
    let path = location.pathname.split('/')[2]

    setTimeout(() => {
      this.setPos(path)
    }, 500)
  },
}
